import styled from 'styled-components';

import { styles } from '../../styles';

export const Tag = styled.div`
  padding: 4px 8px;
  ${styles.rounded.md};
  white-space: nowrap;
`;
